import React from "react";
import { createRoot } from "react-dom/client";
import PrivacyChoicesModal, {
  OPEN_EVENT,
} from "@/cookie_consent/PrivacyChoicesModal";
import GdprBanner from "@/cookie_consent/GdprBanner";
import { readConsentStateMeta } from "@/cookie_consent/consentState";
import "@/cookie_consent/consent.css";

const MOUNT_ID = "cookie-consent-root";
const LINK_SELECTOR = "[data-gc-privacy-choices-link]";

document.addEventListener("DOMContentLoaded", () => {
  const mount = document.getElementById(MOUNT_ID);
  if (!mount) return;

  const state = readConsentStateMeta();
  if (state) {
    // eslint-disable-next-line no-underscore-dangle
    window.__gcConsent = state;
  }

  document.addEventListener("click", (event) => {
    const link = event.target.closest?.(LINK_SELECTOR);
    if (!link) return;
    event.preventDefault();
    document.dispatchEvent(new CustomEvent(OPEN_EVENT));
  });

  const showBanner = state?.jurisdiction === "eu" && state?.setAt == null;

  createRoot(mount).render(
    React.createElement(
      React.Fragment,
      null,
      React.createElement(PrivacyChoicesModal, { initialState: state }),
      showBanner
        ? React.createElement(GdprBanner, { initialState: state })
        : null
    )
  );
});
